import React, { PureComponent } from 'react';
import { func, arrayOf, string, number } from 'prop-types';
import { productShape } from 'shapes';
import { Consumer } from 'contexts/WishList/WishListContext';

class WithWishList extends PureComponent {
    static propTypes = {
        product: productShape.isRequired,
        productId: string.isRequired,
        component: func.isRequired,
        productIds: arrayOf(number),
    };

    static defaultProps = {
        productIds: [],
    };

    static getDerivedStateFromProps(props, state) {
        if (props.productIds && props.productIds !== state.productIds) {
            const { productIds, productId } = props;

            const isInWishList =
                productIds &&
                productIds.some(id => id === parseInt(productId, 10));
            return { isInWishList, productIds };
        }

        return null;
    }

    state = {
        productIds: [], // eslint-disable-line react/no-unused-state
        isInWishList: false,
    };

    render() {
        const { component, product, productIds, ...otherProps } = this.props;
        const { isInWishList } = this.state;
        return React.createElement(component, {
            isInWishList,
            product,
            ...otherProps,
        });
    }
}

export default ConnectedComponent => props => (
    <Consumer>
        {({ actions, state }) => (
            <WithWishList
                productIds={state.productIds}
                openWishlistModal={actions.openWishlistModal}
                {...props}
                component={ConnectedComponent}
                showIconWishlist={state.areProductIdsLoaded}
            />
        )}
    </Consumer>
);
